<template>
  <el-tooltip class="item" effect="dark" placement="top-start" :content="title">
    <img :src="img" :alt="title" />
  </el-tooltip>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import diamond from '@/apps/traforama/assets/icons/diamond.png'
import code from '@/apps/traforama/assets/icons/code.png'
export default defineComponent({
  name: 'PublisherTypeLabel',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const title = computed(() => {
      return props.modelValue
        ? 'Premium external publisher'
        : 'Direct publisher'
    })
    const img = computed(() => {
      return props.modelValue ? diamond : code
    })
    return { title, img }
  }
})
</script>
<style lang="scss" scoped>
img {
  width: 30px;
}
</style>
